/* eslint-disable */
import "./assets/styles/App.css";
import { Routes, Route } from "react-router-dom";
import { Component } from "react";
import HomePage from "./pages/HomePage";
import HomeInterface from "./interfaces/HomeInterface";
import ContactInterface from "./interfaces/ContactInterface";
import Login from "./components/Login";
import Gallery from "./components/Gallery";
import AboutInterface from "./interfaces/AboutInterface";
import AdminPage from "./pages/AdminPage";
import Dashboard from "./components/Admin/scenes/dashboard/index";
import NewPlayer from "./components/Admin/scenes/players/newPlayer";
import ViewPlayer from "./components/Admin/scenes/players/viewPlayers";
import NewCoach from "./components/Admin/scenes/coaches/newCoach";
import ViewCoaches from "./components/Admin/scenes/coaches/viewCoaches";
import EditCoach from "./components/Admin/scenes/coaches/editCoach";
import EditPlayer from "./components/Admin/scenes/players/editPlayer";
import AchievementInterface from "./interfaces/AchievementsInterface";
import AchievementPlayerInterface from "./interfaces/AchievementsPlayerInterface";
import NewAchievement from "./components/Admin/scenes/Achievements/newAchievement";
import ViewAchievements from "./components/Admin/scenes/Achievements/viewAchievements";
import EditAchievement from "./components/Admin/scenes/Achievements/editAchievement";
import Schedules from "./components/Schedules";
import NewSchedule from "./components/Admin/scenes/Schedules/newSchedules";
import ViewSchedules from "./components/Admin/scenes/Schedules/viewSchedules";
import EditSchedules from "./components/Admin/scenes/Schedules/editSchedules";
import NewTrainings from "./components/Admin/scenes/Trainings/newTrainings";
import ViewTrainings from "./components/Admin/scenes/Trainings/viewTrainings";
import EditTrainings from "./components/Admin/scenes/Trainings/editTrainings";
import Trainings from "./components/Trainings";
import NewSponsors from "./components/Admin/scenes/Sponsors/newSponsors";
import ViewSponsors from "./components/Admin/scenes/Sponsors/viewSponsors";
import FAQ from "./components/FAQPage";

function App() {
  return (
    <>
      <Routes>
        <Route path="" element={<HomePage />}>
          <Route path="" element={<HomeInterface />} />
          <Route path="about" element={<AboutInterface />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="contact" element={<ContactInterface />} />
          <Route path="login" element={<Login />} />
          <Route path="achievements" element={<AchievementInterface />} />
          <Route
            path="achievementplayer"
            element={<AchievementPlayerInterface />}
          />
          <Route path="schedules" element={<Schedules />} />
          <Route path="trainings" element={<Trainings />} />
          <Route path="faq" element={<FAQ />} />
        </Route>
        <Route path="admin" element={<AdminPage />}>
          <Route path="" element={<Dashboard />} />
          <Route path="newplayer" element={<NewPlayer />} />
          <Route path="viewplayers" element={<ViewPlayer />} />
          <Route path="editplayer" element={<EditPlayer />} />
          {/* Coaches */}
          <Route path="newcoach" element={<NewCoach />} />
          <Route path="viewcoaches" element={<ViewCoaches />} />
          <Route path="editcoach" element={<EditCoach />} />
          <Route path="newachievement" element={<NewAchievement />} />
          <Route path="viewachievements" element={<ViewAchievements />} />
          <Route path="editachievements" element={<EditAchievement />} />
          <Route path="newschedules" element={<NewSchedule />} />
          <Route path="viewschedules" element={<ViewSchedules />} />
          <Route path="editschedules" element={<EditSchedules />} />
          <Route path="newtrainings" element={<NewTrainings />} />
          <Route path="viewtrainings" element={<ViewTrainings />} />
          <Route path="edittrainings" element={<EditTrainings />} />
          <Route path="newsponsors" element={<NewSponsors />} />
          <Route path="viewsponsors" element={<ViewSponsors />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
